module.exports = __webpack_public_path__ + "img/pnc_img.2ad8177a.png";